(function () {
    function initAGMArchiveTables() {
        document.querySelectorAll('[data-agm-archive-table]').forEach(function (table) {
            var buttons = table.querySelectorAll('.agm-sort-btn');

            buttons.forEach(function (btn) {
                btn.addEventListener('click', function () {
                    var sortKey = btn.getAttribute('data-sort');
                    var currentDir = btn.getAttribute('data-sort-dir');
                    var newDir = currentDir === 'asc' ? 'desc' : 'asc';

                    buttons.forEach(function (b) {
                        b.removeAttribute('data-sort-dir');
                    });
                    btn.setAttribute('data-sort-dir', newDir);

                    var tbody = table.querySelector('.agm-archive-tbody');
                    var rows = Array.from(tbody.querySelectorAll('.agm-archive-row'));

                    rows.sort(function (a, b) {
                        var aVal, bVal;

                        if (sortKey === 'year') {
                            aVal = parseInt(a.getAttribute('data-year'), 10) || 0;
                            bVal = parseInt(b.getAttribute('data-year'), 10) || 0;
                        } else if (sortKey === 'date') {
                            aVal = new Date(a.getAttribute('data-date')).getTime() || 0;
                            bVal = new Date(b.getAttribute('data-date')).getTime() || 0;
                        }

                        if (newDir === 'asc') {
                            return aVal - bVal;
                        }
                        return bVal - aVal;
                    });

                    rows.forEach(function (row) {
                        tbody.appendChild(row);
                    });
                });
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAGMArchiveTables);
    } else {
        initAGMArchiveTables();
    }
})();
